import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0429a742"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-1 flex-col" }
const _hoisted_2 = { class: "flex flex-1 flex-col" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "flex items-center justify-between py-7 m-auto total_text"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-8" }, "每日统计：", -1))
const _hoisted_8 = { class: "flex-1 flex justify-between mx-10" }
const _hoisted_9 = { class: "mr-6" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tableTips" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "block" }, "支持调机正品：（调机数-调机正品）"),
  /*#__PURE__*/_createElementVNode("span", null, "不支持调机正品：调机数")
], -1))
const _hoisted_11 = { class: "flex flex-1" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tableTips" }, "指完工上报时上报的正品数与设备记录的正品数之间的差值", -1))
const _hoisted_13 = { class: "flex items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tableTips" }, "指完工上报时上报的总正品数*单品出数", -1))
const _hoisted_15 = { class: "flex items-center" }
const _hoisted_16 = {
  key: 1,
  class: "flex flex-row justify-between items-center"
}
const _hoisted_17 = ["title"]
const _hoisted_18 = { class: "flex items-center" }

import JTabs, { ITagsData } from "@/components/jtabs-1/index.vue";
import { SearchOutlined } from "@ant-design/icons-vue";
import { ref, reactive, onMounted } from "vue";
import JTable from "@/components/jtable/index.vue";
import JTag from "@/components/jtag/index.vue";
import { ITableData } from "@/components/jtable/tableType";
import API, {
  IPostMachineUploadRecordGetUpLoadRecordBo,
  IPostMachineUploadRecordGetUpLoadRecordCountBo,
  IPostMachineUploadRecordGetUpLoadRecordCountVo,
  IPostMachineUploadRecordGetUpLoadRecordVo,
} from "@/api/reportRecord";
import { GetDateTimeLastStr, GetDateTimeZeroStr, getWekday, getMonthStar } from "@/constant";
import { InfoCircleOutlined } from '@ant-design/icons-vue';
import keyBorad from "@/components/keyborad/keyborad.vue";
//定义生命周期事件

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

onMounted(() => {
  //初始化对日期赋值
  getHomeTableData();
  getStatisticData()
});
// ---------------------数据变量定义-------------------------
//数字键盘状态
let keyBoradShow = ref<boolean>(false);
let totalDataShow = ref<string>('1')
//工单搜索条件
let selectKeys = reactive<IPostMachineUploadRecordGetUpLoadRecordBo>(
  cleanCondtion()
);
//统计条件
let countCondition = reactive<IPostMachineUploadRecordGetUpLoadRecordCountBo>(
  RecordCountCondition()
)
//统计列表
let countListData = ref<IPostMachineUploadRecordGetUpLoadRecordCountVo>({})
let tableList = ref<
  ITableData<IPostMachineUploadRecordGetUpLoadRecordVo>
>({
  total: 0,
  list: [],
});
let tagsTag: any = ref([
  { name: "今日", value: "1" },
  { name: "昨日", value: "2" },
  { name: "本周", value: "3" },
  { name: "本月", value: "4" },
]);

// 表格
const tableConfig = {
  columns: [
    {
      title: "序号",
      key: "row",
      width: 150,
    },
    {
      title: "工单单号",
      dataIndex: "workOrderCode",
      key: "workOrderCode",
      width: 250,
      ellipsis: true,
    },
    {
      title: "上报类型",
      dataIndex: "commitType",
      key: "commitType",
      width: 180,
    },
    {
      title: "客户名称",
      dataIndex: "customerName",
      key: "customerName",
      width: 200,
      ellipsis: true,
    },
    {
      title: "产品名称",
      dataIndex: "productName",
      key: "productName",
      width: 200,
      ellipsis: true,
    },
    {
      title: "工序名称",
      dataIndex: "processName",
      key: "processName",
      width: 200,
      ellipsis: true,
    },
    {
      title: "来料数",
      dataIndex: "preProcedureOutQty",
      key: "preProcedureOutQty",
      width: 180,
    },
    {
      title: "本次计划产量",
      dataIndex: "planOutput",
      key: "planOutput",
      width: 180,
      ellipsis: true,
    },
    {
      title: "总投料数",
      dataIndex: "totalInQty",
      key: "totalInQty",
      width: 180,
    },
    {
      title: "调机数",
      dataIndex: "adjustmentOutput",
      key: "adjustmentOutput",
      width: 180,
    },
    {
      title: "调机正品数",
      dataIndex: "debugGoodQty",
      key: "debugGoodQty",
      width: 200,
    },
    {
      title: "正品数",
      dataIndex: "goodOutput",
      key: "goodOutput",
      width: 180,
    },
    {
      title: "正品调整数",
      dataIndex: "goodAdjustmentQty",
      key: "goodAdjustmentQty",
      width: 220,
    },
    {
      title: "工废数",
      dataIndex: "workBadOutput",
      key: "workBadOutput",
      width: 200,
    },
    {
      title: "材废数",
      dataIndex: "makingsBadOutput",
      key: "makingsBadOutput",
      width: 200,
    },
    {
      title: "出料数",
      dataIndex: "totalOutQty",
      key: "totalOutQty",
      width: 180,
    },
    {
      title: "生产时间",
      dataIndex: "productionTime",
      key: "productionTime",
      width: 300,
      ellipsis: true,
    },
    {
      title: "上报时间",
      dataIndex: "uploadTime",
      key: "uploadTime",
      width: 300,
      ellipsis: true,
    },
    {
      title: '上机人员',
      dataIndex: 'userNameList',
      key: 'userNameList',
      width: 300,
      ellipsis: true,
    },
    {
      title: "修改原因",
      dataIndex: "adjustmentReason",
      key: "adjustmentReason",
      width: 300,
      ellipsis: true,
    }
  ],
};

// ---------------------方法定义-------------------------

const dateChange = (page: ITagsData) => {
  totalDataShow.value = page.value
  switch (page.value) {
    case "1":
      //今日
      selectKeys.workOrderPlanStartTime = GetDateTimeZeroStr(0);
      selectKeys.workOrderPlanEndTime = GetDateTimeLastStr(0);

      break;
    case "2":
      //昨日
      selectKeys.workOrderPlanStartTime = GetDateTimeZeroStr(-1);
      selectKeys.workOrderPlanEndTime = GetDateTimeLastStr(-1);
      break;
    case "3":
      //本周
      selectKeys.workOrderPlanStartTime = getWekday("s", 0);
      selectKeys.workOrderPlanEndTime = GetDateTimeLastStr(0);
      break;
    case "4":
      //本月
      selectKeys.workOrderPlanStartTime = getMonthStar();
      selectKeys.workOrderPlanEndTime = GetDateTimeLastStr(0);
      break;
    default:
      break;
  }
  getHomeTableData();
}
const openKeyboard = () => {
  selectKeys.workOrderCode = ''
  keyBoradShow.value = true
}
const putKeyBorad = (value) => {
  if (value == 'off') {
    keyBoradShow.value = false
    onSearch()
    return
  }
  selectKeys.workOrderCode = value || ''

}

//获取列表数据
const getHomeTableData = () => {
  getTableData(1, 20);
};

const getTableData = (current: number, pageSize: number) => {
  selectKeys.pageNo = current;
  selectKeys.pageSize = pageSize;
  API.postMachineUploadRecordGetUpLoadRecord(selectKeys)
    .then((res: any) => {
      tableList.value.total = 0;
      tableList.value.list = [];
      if (res.list.length > 0) {
        tableList.value = res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};
const getStatisticData = () => {
  API.postMachineUploadRecordGetUpLoadRecordCount(countCondition).then(res => {
    countListData.value = res
  })
}

function cleanCondtion() {
  return {

    /*
    * 页码
    */
    pageNo: 1,
    /**
     * 分页大小
     */
    pageSize: 30,
    /**
     * 工单编号，可以为空
     */
    workOrderCode: "",
    /**
     * 工单计划执 结束时间 yyyy-MM-dd HH:mm:ss
     */
    workOrderPlanEndTime: GetDateTimeLastStr(0),
    /**
     * 工单计划执 开始时间 yyyy-MM-dd HH:mm:ss
     */
    workOrderPlanStartTime: GetDateTimeZeroStr(0),
  };
}
function RecordCountCondition() {
  return {
    /**
       * 统计时间范围分类：day表示天，week表示周，month表示年，目前只支持day
       */
    timeScope: 'day',
    /**
     * 工单编号
     */
    workOrderCode: '',
    /**
     * 工单计划执行结束时间 yyyy-MM-dd HH:mm:ss
     */
    workOrderPlanEndTime: GetDateTimeLastStr(0),
    /**
     * 工单计划执行开始时间 yyyy-MM-dd HH:mm:ss
     */
    workOrderPlanStartTime: GetDateTimeZeroStr(0),
  }

}

const onSearch = () => {
  getHomeTableData();
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(JTabs, {
            "tags-data": _unref(tagsTag),
            onSwitchTags: dateChange,
            canceTags: false,
            defaultTag: '1'
          }, null, 8, ["tags-data"]),
          _hoisted_5,
          _createVNode(_component_a_input, {
            onClick: openKeyboard,
            style: _normalizeStyle({ flex: `0 0 ${_ctx.$px2rem('332px')}`, color: 'white' }),
            value: _unref(selectKeys).workOrderCode,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(selectKeys).workOrderCode) = $event)),
            readonly: "",
            placeholder: "请输入工单编号",
            size: "large"
          }, null, 8, ["style", "value"]),
          _createVNode(_component_a_button, {
            onClick: onSearch,
            style: _normalizeStyle({ borderColor: 'rgba(255, 255, 255, 0.1)', borderLeft: '0', color: 'white', height: _ctx.$px2rem('48px'), fontSize: _ctx.$px2rem('24px'), })
          }, {
            icon: _withCtx(() => [
              _createVNode(_unref(SearchOutlined))
            ]),
            default: _withCtx(() => [
              _createTextVNode(" 搜索")
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        (_unref(totalDataShow) === '1')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", null, [
                  _createTextVNode("完成工单数："),
                  _createElementVNode("span", null, _toDisplayString(_unref(countListData)?.finishWorkOrderTotal || 0), 1)
                ]),
                _createElementVNode("span", null, [
                  _createTextVNode("总正品数："),
                  _createElementVNode("span", null, _toDisplayString(_unref(countListData)?.goodOutputTotal || 0), 1)
                ]),
                _createElementVNode("span", null, [
                  _createTextVNode("总工废数："),
                  _createElementVNode("span", null, _toDisplayString(_unref(countListData)?.workBadOutputTotal || 0), 1)
                ]),
                _createElementVNode("span", null, [
                  _createTextVNode("总材废数："),
                  _createElementVNode("span", null, _toDisplayString(_unref(countListData)?.makingsBadOutputTotal || 0), 1)
                ]),
                _createElementVNode("span", _hoisted_9, [
                  _createTextVNode("总调机废品 "),
                  _createVNode(_component_a_tooltip, {
                    placement: "bottom",
                    trigger: "click"
                  }, {
                    title: _withCtx(() => [
                      _hoisted_10
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(InfoCircleOutlined), { class: "tableTipsIcon" })
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" ："),
                  _createElementVNode("span", null, _toDisplayString(_unref(countListData)?.adjustmentBadQtyTotal || 0), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(JTable, {
          "cur-page": 1,
          "page-size": 20,
          columns: tableConfig.columns,
          data: _unref(tableList),
          paginationPosition: "bottomRight",
          onUpdateData: getTableData
        }, {
          header: _withCtx(({ title }) => [
            (title === '正品调整数')
              ? (_openBlock(), _createBlock(_component_a_tooltip, {
                  key: 0,
                  placement: "bottom",
                  trigger: "click"
                }, {
                  title: _withCtx(() => [
                    _hoisted_12
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_13, [
                      _createTextVNode(_toDisplayString(title) + " ", 1),
                      _createVNode(_unref(InfoCircleOutlined), { class: "tableTipsIcon" })
                    ])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (title === '出料数')
              ? (_openBlock(), _createBlock(_component_a_tooltip, {
                  key: 1,
                  placement: "bottom",
                  trigger: "click"
                }, {
                  title: _withCtx(() => [
                    _hoisted_14
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_15, [
                      _createTextVNode(_toDisplayString(title) + " ", 1),
                      _createVNode(_unref(InfoCircleOutlined), { class: "tableTipsIcon" })
                    ])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          cell: _withCtx(({ column, index, record }) => [
            (column.key === 'row')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(index + 1), 1)
                ], 64))
              : _createCommentVNode("", true),
            (column.key == 'workOrderCode')
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", {
                    class: "mr-4 flex-1 overflow-hidden mainechName_text",
                    title: record.workOrderCode
                  }, _toDisplayString(record.workOrderCode), 9, _hoisted_17),
                  (record.urgent == 'y')
                    ? (_openBlock(), _createBlock(JTag, {
                        key: 0,
                        class: "jtag"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("急")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (column.key === 'commitType')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createTextVNode(_toDisplayString(record.commitType == 'head' ? "手动" : record.commitType == 'auto' ? "自动" : ''), 1)
                ], 64))
              : _createCommentVNode("", true),
            (column.key == 'adjustmentReason')
              ? (_openBlock(), _createBlock(_component_a_tooltip, {
                  key: 3,
                  placement: "topLeft",
                  trigger: "click"
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("div", {
                      style: _normalizeStyle({ fontSize: _ctx.$px2rem('22px'), })
                    }, _toDisplayString(record.adjustmentReason), 5)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_18, _toDisplayString(record.adjustmentReason), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["columns", "data"])
      ])
    ]),
    (_unref(keyBoradShow))
      ? (_openBlock(), _createBlock(keyBorad, {
          key: 0,
          value: _unref(selectKeys).workOrderCode,
          onPutKeyBorad: putKeyBorad
        }, null, 8, ["value"]))
      : _createCommentVNode("", true)
  ]))
}
}

})